import { Text, Container, Group, Image, useMantineTheme, Title } from '@mantine/core';
import { IconMapPinFilled, IconPhoneFilled, IconMailFilled } from '@tabler/icons-react';
import classes from './../../styles/Footer.module.css';
import { useEffect, useRef, useState } from 'react';
import { Carousel } from '@mantine/carousel';
import Autoplay from 'embla-carousel-autoplay';
import Cookies from 'universal-cookie';
import useStore from '../../store/useStore';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const cookies = new Cookies(null, { path: '/' });


export function BannerHeader() {
    const theme = useMantineTheme();
    const autoplay = useRef(Autoplay({ delay: 5000 }));
    const dataStore = useStore((state: any) => state.store);

    return (
        <section style={{marginTop: dataStore?.topBar && dataStore?.topBar?.show && "content" in dataStore?.topBar && dataStore?.topBar?.content !== "" ? 120 : 80}}>
            {dataStore?.header?.filter((item: any) => item !== "")?.length > 1
                ? <Carousel dir='ltr' loop dragFree align="start" plugins={[autoplay.current]} onMouseEnter={autoplay.current.stop} onMouseLeave={autoplay.current.reset}>
                    {dataStore?.header?.map((item: any, index: number) => (
                        item !== ""
                        ? <Carousel.Slide key={index}>
                            <LazyLoadImage
                                src={`${process.env.REACT_APP_API_URL_IMAGES}/${item}.webp`}
                                alt={""}
                                height={"100%"}
                                width={"100%"}
                                style={{maxHeight: "calc(100vh - 80px)", objectFit: 'fill'}}
                                delayTime={0}
                                placeholderSrc={`${process.env.REACT_APP_API_URL_THUMBNAILS}/${item}.webp`}
                            />
                        </Carousel.Slide>
                        : null
                    ))}
                </Carousel>
                : <LazyLoadImage
                    src={`${process.env.REACT_APP_API_URL_IMAGES}/${dataStore?.header?.filter((item: any) => item !== "")?.[0]}.webp`}
                    alt={""}
                    height={"100%"}
                    width={"100%"}
                    style={{maxHeight: "calc(100vh - 80px)", objectFit: 'fill'}}
                    delayTime={0}
                    placeholderSrc={`${process.env.REACT_APP_API_URL_THUMBNAILS}/${dataStore?.header?.filter((item: any) => item !== "")?.[0]}.webp`}
                />
            }
        </section>
    );
}